/*
  TMA — mobile navigation drawer.

  Replaces Eurus's mobile-navigation, which rendered its own menu in its own
  type and colours. On a phone that meant the primary navigation was the old
  theme showing the old links.

  PROGRESSIVE ENHANCEMENT. The drawer needs JavaScript, so the trigger stays
  hidden until this file runs and sets data-tma-nav="ready" on <html>. Until
  then the stylesheet shows the nav links inline instead, so the links are
  reachable whether or not this ever loads.

  Accessibility, since a drawer is a modal surface:
  * focus moves into the panel on open and back to the trigger on close
  * Tab is trapped inside the panel while it is open
  * Escape closes it
  * the page behind cannot scroll
  * the trigger's aria-expanded tracks the state
*/
(function () {
  'use strict';

  var drawer = document.getElementById('tma-drawer');
  var trigger = document.querySelector('[data-tma-nav-open]');
  if (!drawer || !trigger) return;

  /* Tell the stylesheet the drawer is usable, which reveals the trigger and
     hides the inline fallback list. */
  document.documentElement.setAttribute('data-tma-nav', 'ready');

  var panel = drawer.querySelector('.tma-drawer-panel');
  var lastFocus = null;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return [].slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    /* Force a reflow so the browser records the closed position, then flip the
       class synchronously. requestAnimationFrame would be tidier but it is
       throttled in background tabs, which would leave the drawer marked open
       while the panel sat off screen. */
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('tma-nav-locked');

    var first = focusables()[0];
    if (first) first.focus();

    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    drawer.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('tma-nav-locked');
    document.removeEventListener('keydown', onKeydown);

    /* wait for the slide-out before removing it from the accessibility tree */
    var done = function () { drawer.hidden = true; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else setTimeout(done, 320);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  trigger.addEventListener('click', open);

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-tma-nav-close]')) close();
  });

  /* Following a link inside the drawer navigates; close first so returning
     via the back button does not land on an open drawer. */
  drawer.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (link) close();
  });

  /* If the viewport grows past the point where the desktop nav takes over,
     an open drawer would be stranded on screen. */
  if (window.matchMedia) {
    var wide = window.matchMedia('(min-width: 761px)');
    var onChange = function (e) { if (e.matches && !drawer.hidden) close(); };
    if (wide.addEventListener) wide.addEventListener('change', onChange);
    else if (wide.addListener) wide.addListener(onChange);
  }
})();
